
import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const HeroSlidesContext = createContext({
    slides: [],
    loading: true,
    refresh: () => { }
});

export const useHeroSlidesData = () => useContext(HeroSlidesContext);

export const HeroSlidesProvider = ({ children }) => {
    const [slides, setSlides] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        setLoading(true);
        try {
            const res = await pb.collection('hero_slides').getList(1, 200, {
                sort: '+order, created'
            });
            setSlides(res.items || []);
        } catch (err) {
            console.error("Error loading hero slides data:", err);
            setSlides([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <HeroSlidesContext.Provider value={{ slides, loading, refresh: loadData }}>
            {children}
        </HeroSlidesContext.Provider>
    );
};
